export const brands = [
  {
    id: 'telegraaf',
    name: 'De Telegraaf',
    logo: `${process.env.PUBLIC_URL}/assets/brands/de telegraaf.svg`,
    image: `${process.env.PUBLIC_URL}/assets/brandvisuals/card-telegraaf.jpg`,
    heroImage: `${process.env.PUBLIC_URL}/assets/brandvisuals/hero-telegraaf.jpg`,
    description: '<p>De Telegraaf is een van de belangrijkste mediamerken van Nederland. Een instituut in het medialandschap. </p><h3>Onafhankelijk en uitgesproken</h3><p>De Telegraaf heeft het grootste bereik van alle dagbladen en staat in contact met ruim 50% van de Nederlandse bevolking. In heldere taal, dicht bij de lezer. Via papier en digitaal.</p>',
    website: 'https://www.telegraaf.nl',
    region: 'Landelijk',
    type: 'Landelijk dagblad',
    brandReach: '6.6MLN',
    brandPageviews: '5.1MLN',
    brandReachRegion: '100%',
    brandReadIntensity: '92%',
    brandReachSocialFollowers: '2.2MLN'
  },
  {
    id: 'noordhollands-dagblad',
    name: 'Noordhollands Dagblad',
    logo: `${process.env.PUBLIC_URL}/assets/brands/nhd.svg`,
    image: `${process.env.PUBLIC_URL}/assets/brandvisuals/card-nhd.jpg`,
    heroImage: `${process.env.PUBLIC_URL}/assets/brandvisuals/hero-nhd.jpg`,
    description: '<p>Met al het nieuws uit West-Friesland, Schagen, Kennemerland, Den Helder, de Zaanstreek, Waterland en Alkmaar. </p><h3>Midden in de regio</h3><p>De krant houdt de lezer op de hoogte van het laatste en meest opmerkelijke nieuws uit de regio en ver daarbuiten. Ze verschijnt in zeven regionale edities. Ook digitaal dicht op de lezer. </p>',
    website: 'https://www.noordhollandsdagblad.nl',
    region: 'Noord-Holland',
    type: 'Regionaal dagblad',
    brandReach: ' ',
    brandPageviews: ' ',
    brandReachRegion: ' %',
    brandReadIntensity: ' %',
    brandReachSocialFollowers: ''
  },
  {
    id: 'dvhn',
    name: 'Dagblad van het Noorden',
    logo: `${process.env.PUBLIC_URL}/assets/brands/dagblad van het noorden.svg`,
    image: `${process.env.PUBLIC_URL}/assets/brandvisuals/card-dvhn.jpeg`,
    heroImage: `${process.env.PUBLIC_URL}/assets/brandvisuals/hero-dvhn.jpeg`,
    description: '<p>Wij zijn Dagblad van het Noorden, een onmisbare nieuwsbron voor iedereen in Drenthe en Groningen. We zijn betrouwbaar, kritisch, onderzoekend en dichtbij. Wij weten wat er speelt in de regio en wat belangrijk is voor de mensen die er wonen. Dagblad van het Noorden kenmerkt zich door een groot bereik en hoge leesintensiteit. </p> <h3>Onafhankelijk en uitgesproken</h3><p>We verslaan en ordenen het nieuws in de regio op alle mogelijke manieren, door verslaggeving, reportages en analyses in tekst, (bewegend) beeld en geluid. We zijn een verbindende factor in de samenleving. We zitten in de haarvaten van de regio, brengen mensen met elkaar in contact en stellen ze in staat om zich actief te bemoeien met het nieuws in hun omgeving. De lezers van dit dagblad zijn betrokken en onze ambassadeurs.</p>',
    website: 'https://www.dvhn.nl',
    region: 'Groningen en Drenthe',
    type: 'Regionaal dagblad',
    brandReach: '923K',
    brandPageviews: '45K',
    brandReachRegion: '',
    brandReadIntensity: '',
    brandReachSocialFollowers: '154K'
  },
  {
    id: 'lc',
    name: 'Leeuwarder Courant',
    logo: `${process.env.PUBLIC_URL}/assets/brands/leeuwarder courant.svg`,
    image: `${process.env.PUBLIC_URL}/assets/brandvisuals/card-leeuwardercourant.jpg`,
    heroImage: `${process.env.PUBLIC_URL}/assets/brandvisuals/hero-lc.jpg`,
    description: '<p>Leeuwarder Courant, de hartslag van Friesland. Sinds 1752 is de Leeuwarder Courant de krant van en voor heel Friesland. Of het nu gaat om ‘groot’ of ‘klein’ nieuws: LC is altijd betrokken. Samen met jou leven we mee met alles wat Friesland beweegt. Leeuwarder Courant kenmerkt zich door een groot bereik en hoge leesintensiteit.</p> <h3>Onafhankelijk en uitgesproken</h3><p>We verslaan en ordenen het nieuws in de regio op alle mogelijke manieren, door verslaggeving, reportages en analyses in tekst, (bewegend) beeld en geluid. Wij zijn de verbindende factor in Friesland met nieuws gedreven activiteiten voor de regio. We zitten in de haarvaten van de regio, scheppen relaties en bouwen communities middels nieuws gedreven content en activiteiten die relevant te zijn voor onze lezers, gebruikers en abonnees.</p>',
    website: 'https://www.lc.nl',
    region: 'Friesland',
    type: 'Regionaal dagblad',
    brandReach: '529K',
    brandPageviews: '',
    brandReachRegion: '47 %',
    brandReadIntensity: '86 %',
    brandReachSocialFollowers: '93K'
  },
  {
    id: 'delimburger',
    name: 'De Limburger',
    subTitle: 'De grootste regiokrant van Nederland ',
    logo: `${process.env.PUBLIC_URL}/assets/brands/de limburger.svg`,
    image: `${process.env.PUBLIC_URL}/assets/brandvisuals/card-limburger.jpeg`,
    heroImage: `${process.env.PUBLIC_URL}/assets/brandvisuals/hero-limburger.jpeg`,
    description: '<h2>Dé Limburgse nieuwsmaker</h2><p>Betrouwbaar, onpartijdig en onafhankelijk nieuws voor álle Limburgers. Het regionale en lokale Limburgse nieuws uiteraard, maar ook binnen- en buitenlands nieuws, sport, economie, entertainment en cultuur. Via app en web, op social media en met de papieren krant.</p><h2>Gesprek van de dag</h2><p>Trots op Limburg waar het kan, kritisch waar het moet. De Limburger bepaalt het gesprek van de dag. Een perfecter umfeld voor een Limburgse mediacampagne is nauwelijks denkbaar.</p>',
    website: 'https://www.delimburger.nl',
    region: 'Limburg',
    type: 'Regionaal dagblad',
    brandReach: '603K',
    brandPageviews: '28MLN',
    brandReachRegion: '55%',
    brandReadIntensity: '92%',
    brandReachSocialFollowers: '166K'
  }
]; 